import { Redirect, Route } from "react-router-dom";
import React from "react";
import { useSelector } from "react-redux";

import { useSession } from "../components/Hooks/UserHooks";
import { RoleEnum } from "../enums";
import { AccountState } from "../store/slices/accountSlice";

export const AuthProtected = (props: any) => {
  const { token } = useSession();

  if (!token) {
    return (
      <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return <>{props.children}</>;
};

export const AccessRoute = ({
  component: Component,
  allowedRoles,
  ...rest
}: any) => {
  const profile = useSelector(
    (state: { account: AccountState }) => state.account?.userProfile,
  );

  return (
    <Route
      {...rest}
      render={(props) => {
        if (
          allowedRoles?.length &&
          (!profile?.role?.key || !allowedRoles.includes(profile.role.key))
        ) {
          return <Redirect to="/dashboard" />;
        }

        return <Component {...props} />;
      }}
    />
  );
};

/** Page-level guard for Super Admin–only Monitoring screens. */
export const RequireSuperAdmin = ({ children }: { children: React.ReactNode }) => {
  const profile = useSelector(
    (state: { account: AccountState }) => state.account?.userProfile,
  );

  if (!profile?.role?.key) {
    return null;
  }

  if (profile.role.key !== RoleEnum.SUPER_ADMIN) {
    return <Redirect to="/dashboard" />;
  }

  return <>{children}</>;
};
